<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between align-items-center catalogo-text text-sm"
          >
            Catálogo de puestos
            <router-link :to="{ name: 'NuevoPuesto' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Puesto
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #nombre="{item}">
                <td class="py-2">{{ item.payload.nombre }}</td>
              </template>
              <template #over-table>
                <CInput
                  v-model="filter"
                  @input="searchTimeOut()"
                  placeholder="Búsqueda por puestos..."
                />
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'EditarPuesto',
                      params: { id: item.id }
                    }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton color="danger" square size="sm" @click="toggleCancel(index, item)">Borrar</CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Puesto"
      color="danger"
    >
      <h5 class="text-center">¿Deseas borrar el puesto {{ itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Borrar Puesto</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="deletePuesto(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
const fields = [
  { key: "nombre", label: "Puesto", _style: "width:100%" },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Puestos",

  data() {
    return {
      items: [],
      fields,
      filter: "",
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      error: "",
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.isLoading = true;
    this.$store
      .dispatch("customHTTP", {
        schema: "puestos",
        limit: 50,
        page: 1,
        ["with-storage"]: ["*"]
      })
      .then(res => {
        this.items = res.data;
        this.pages = res.paginate.last_page;
        this.page = res.paginate.current_page;
      })
      .catch(err => console.log(err))

      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.items.filter(i =>
        i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          schema: "puestos",
          limit: 50,
          page: 1,
          filter: {
            orwhere: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          schema: "puestos",
          limit: 50,
          page: event,
          filter: {
            orwhere: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${this.filter.toUpperCase()}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          },
          ["with-storage"]: ["*"]
        })
      ];
      Promise.all(catalogo)
        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },

    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deletePuesto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "puestos",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
